import { getDefaultHeight, SVG } from "./utils";

export const ToggledIcon: React.FC<React.SVGProps<SVGSVGElement>> = (
  svgProps,
) => {
  return (
    <SVG
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 13 14"
      height={getDefaultHeight(svgProps, 14)}
      {...svgProps}
    >
      <rect y="8.1" width="13" height="5.9" rx="3" fill="#090B19" />
      <ellipse cx="9.8" cy="11" rx="2.1" ry="2" fill="#fff" />
      <rect width="13" height="6.1" rx="3.1" fill="#090B19" fillOpacity=".2" />
      <ellipse cx="3.3" cy="3.1" rx="2.2" ry="2" fill="#fff" />
    </SVG>
  );
};
